import styled from '@emotion/styled';
import { Button } from '~/shared/components/Button';
import { Text } from '~/shared/components/Text';
import { breakpoints } from '~/theme';

export const Wrapper = styled.div(({ theme }) => ({
    '--columns': 1,
    '--gap': theme.space[5],
    display: 'grid',
    gridTemplateColumns: 'repeat(var(--columns), minmax(0, 1fr))',
    gap: 'var(--gap)',

    [breakpoints.sm]: {
        '--columns': 12,
    },
}));

export const Navigation = styled.nav(({ theme }) => ({
    display: 'none',
    marginBottom: theme.space[8],

    [breakpoints.sm]: {
        display: 'block',
        maxWidth: 250,
        gridColumn: '1 / span 4',
    },

    [breakpoints.md]: {
        gridColumn: '1 / span 3',
    },
}));

export const Content = styled.div({
    gridColumn: '1 / -1',

    [breakpoints.sm]: {
        gridColumn: '5 / -1',
    },
    [breakpoints.md]: {
        gridColumn: '4 / -1',
    },
});

export const PageTitle = styled(Text)(({ theme }) => ({
    marginBottom: theme.space[4],

    [breakpoints.sm]: {
        marginBottom: theme.space[6],
    },
}));

export const FiltersContainer = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    minHeight: theme.space[4],
}));

export const FilterAndSortingWrapper = styled.div(({ theme }) => ({
    order: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.space[2],

    [breakpoints.sm]: {
        justifyContent: 'flex-end',
        marginBottom: theme.space[2],
        order: 2,
    },
}));

export const FiltersButtonMobile = styled(Button)(() => ({
    [breakpoints.sm]: {
        display: 'none',
    },
}));
